import { ITenant, IUnitMix } from './types';

export const getOperationsIncomeTotals = (isApartment: boolean, unitArray: IUnitMix[], tenantArray: ITenant[]) => {
    let totalRentalIncome = 0;
    let totalIncomeUnits = 0;
    let totalSFPerUnits = 0;

    if (isApartment) {
        totalRentalIncome = unitArray.reduce((sum, unit) => sum + (unit.totalRent ?? 0), 0);
        totalIncomeUnits = unitArray.reduce((sum, unit) => sum + (unit.units || 0), 0);
        totalSFPerUnits = unitArray.reduce((sum, unit) => sum + ((unit.averageSquareFootage || 0) * (unit.units || 0)), 0);
    } else {
        totalRentalIncome = tenantArray.reduce((sum, tenant) => sum + (tenant.totalRent ?? 0), 0);
        totalIncomeUnits = tenantArray.length;
        totalSFPerUnits = tenantArray.reduce((sum, tenant) => sum + (tenant.squareFootage || 0), 0);
    }

    return {
        totalRentalIncome,
        totalIncomeUnits,
        totalSFPerUnits,
    };
};
